import { render } from "./VRParkCasesPage.vue?vue&type=template&id=2be3e71f&scoped=true"
import script from "./VRParkCasesPage.vue?vue&type=script&lang=js"
export * from "./VRParkCasesPage.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=2be3e71f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be3e71f"]])

export default __exports__